module.exports = __webpack_public_path__ + "static/logo-windward-5a8d71176913c8d32b62d74c26fee0e5.png";